export const selectAppointments = (state) => state.appointments.appointments;

export const selectAppointmentsError = (state) => state.appointments.error;

export const selectIsNewAppointment = (state) =>
  state.appointments.isNewAppointment;
